import { createContext, FC, ReactNode, useState } from "react";

export type QuickFilterPortalContextType = {
	isDataGridScreen: boolean;
	setIsDataGridScreen: (isDataGridScreen: boolean) => void;
	filterText: string;
	setFilterText: (filterText: string) => void;
};

type Props = {
	children: ReactNode;
};

export const QuickFilterPortalContext = createContext<QuickFilterPortalContextType | null>(null);

export const QuickFilterPortalProvider: FC<Props> = ({ children }) => {
	const [isDataGridScreen, setIsDataGridScreen] = useState<boolean>(false);
	const [filterText, setFilterText] = useState<string>('');
	
	return (
		<QuickFilterPortalContext.Provider
			value={{
				isDataGridScreen: isDataGridScreen,
				setIsDataGridScreen: setIsDataGridScreen,
				filterText: filterText,
				setFilterText: setFilterText
			}}
		>
			{children}
		</QuickFilterPortalContext.Provider>
	);
};
